import React, { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useCatalog } from "@/context/CatalogContext";
import { useCart } from "@/context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reorder() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { addItem, setOpen } = useCart();
  const { getProduct } = useCatalog();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const ref = params.get("ref"), email = params.get("email");
    if (!ref || !email) { navigate("/track"); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/orders/lookup`, { ref, email });
        let added = 0;
        data.items.forEach((it) => {
          const p = getProduct(it.id);
          if (p) { addItem(p, it.qty); added++; }
        });
        if (added) { setOpen(true); toast.success(`Reordered ${added} item(s) from ${data.order_ref}`); }
        else toast.error("These items are no longer available");
      } catch (e) {
        toast.error("Could not find that order");
        navigate("/track");
        return;
      }
      navigate("/");
    })();
  }, [params, navigate, addItem, setOpen, getProduct]);

  return (
    <main className="pt-40 pb-24 min-h-screen text-center" data-testid="reorder-page">
      <p className="font-mono text-sm text-[#A1A1AA]">Rebuilding your order…</p>
    </main>
  );
}
